tmVisitorStore = function () {
    return {
        // name / phone / email (form pre-fill) are Preferences: kept only with consent, the forms work without it.
        // The identifier (the signed-out wishlist key) is necessary (Consent banner, COOL 166).
        saveDetails: function (name = '', phone = '', email = '', identifier = '') {
            try {
                if (!tmUtils.consentAllows('preferences')) {
                    name = phone = email = '';
                }
                if (name.length > 0) {
                    Cookies.set('tmv-name', name, { expires: 365, secure: true });
                }
                if (phone.length > 0) {
                    Cookies.set('tmv-phone', phone, { expires: 365, secure: true });
                }
                if (email.length > 0 && tmUtils.validateEmailString(email)) {
                    Cookies.set('tmv-email', email, { expires: 365, secure: true });
                }
                if (identifier.length > 0) {
                    // Never SameSite=Strict: a magic link is a cross-site navigation from the mail app, and the sign-in
                    // it lands on needs this cookie to move the visitor's wishlists into the account.
                    Cookies.set('tmv-identifier', identifier, { expires: 365, secure: true });
                }
            } catch (e) {}
        },

        getDetail: function (what) {
            let returnValue = '';
            try {
                if (what === 'name') {
                    returnValue = Cookies.get('tmv-name') ?? '';
                }
                else if (what === 'phone') {
                    returnValue = Cookies.get('tmv-phone') ?? '';
                }
                else if (what === 'email') {
                    returnValue = Cookies.get('tmv-email') ?? '';
                }
                else if (what === 'identifier') {
                    returnValue = Cookies.get('tmv-identifier') ?? '';
                }
                else {
                    returnValue = Cookies.get(what) ?? '';
                }
            } catch (e) {}
            return typeof returnValue === 'undefined' ? '' : returnValue
        },

        saveDetail: function (key, value) {
            try {
                Cookies.set(key, value, { expires: 365, secure: true });
            } catch (e) {}
        },

        deleteDetail: function (key) {
            try {
                Cookies.remove(key);
            } catch (e) {}
        },

        setAsInternalUser: function () {
            try {
                Cookies.set('tmv-internal-user', 'yes', { expires: 365, secure: true });
            } catch (e) {}
        },

        isInternalUser: function () {
            let returnValue = false;
            try {
                returnValue = Cookies.get('tmv-internal-user') === 'yes';
            } catch (e) {}
            return returnValue;
        },

        setCurrency: function (currencyCode) {
            try {
                Cookies.set('tmv-currency', currencyCode.toUpperCase(), { expires: 365, secure: true });
            } catch (e) {}
        },

        getCurrency: function (useDefaultCurrency = 'USD') {
            let returnValue = useDefaultCurrency;
            try {
                returnValue = Cookies.get('tmv-currency') ?? returnValue;
            } catch (e) {}
            return typeof returnValue === 'undefined' ? returnValue : returnValue
        },

        // The header's language (a TmLanguage code), kept like tmv-currency so PHP can read it too: Account settings shows
        // it when the account has no Language saved, and the checkout's tour guide default follows it
        // (TmUser::getHeaderLanguage). Written by tmAuth.syncHeaderLanguage once the picker has drawn (Peter, 2026-10-08)
        setLanguage: function (languageCode) {
            try {
                Cookies.set('tmv-language', languageCode, { expires: 365, secure: true });
            } catch (e) {}
        },

        getLanguage: function (defaultLanguage = '') {
            let returnValue = defaultLanguage;
            try {
                returnValue = Cookies.get('tmv-language') ?? returnValue;
            } catch (e) {}
            return returnValue;
        },

        // The visitor's temperature unit, 'C' or 'F' ('' = none saved, the unit then follows the country): kept like
        // tmv-currency so PHP reads it too (TmTemperature::getPreference). Account settings writes it for an account with
        // one saved (process-update-profile.php, tmAuth.applySitePreferences); read and written through tmTemperature
        setTemperature: function (unit) {
            try {
                if (unit === 'C' || unit === 'F') {
                    Cookies.set('tmv-temperature', unit, { expires: 365, secure: true });
                }
                else {
                    Cookies.remove('tmv-temperature');
                }
            } catch (e) {}
        },

        getTemperature: function () {
            let returnValue = '';
            try {
                returnValue = Cookies.get('tmv-temperature') ?? '';
            } catch (e) {}
            return returnValue === 'C' || returnValue === 'F' ? returnValue : '';
        },

        // The visitor's measurement system, 'imperial' or 'metric' ('' = none saved, the system then follows the country):
        // kept like tmv-temperature so PHP reads it too (TmMeasurement::getPreference). Account settings writes it for an
        // account with one saved (process-update-profile.php, tmAuth.applyMeasurementPreference); read and written through tmMeasurement
        setMeasurement: function (unit) {
            try {
                if (unit === 'imperial' || unit === 'metric') {
                    Cookies.set('tmv-measurement', unit, { expires: 365, secure: true });
                }
                else {
                    Cookies.remove('tmv-measurement');
                }
            } catch (e) {}
        },

        getMeasurement: function () {
            let returnValue = '';
            try {
                returnValue = Cookies.get('tmv-measurement') ?? '';
            } catch (e) {}
            return returnValue === 'imperial' || returnValue === 'metric' ? returnValue : '';
        },

        // Visitor country (ISO 3166-1 alpha-2, lower case): Cloudflare's answer on the FIRST visit, kept a year in
        // tmv-country — the one place the front end and PHP (getVisitorCountryIso2(), same cookie) agree on. Pages are
        // cached, so the lookup is client-side: /cdn-cgi/trace ("loc=CA") on any Cloudflare-fronted site; nothing on
        // MAMP. ?tm_country=xx on the URL overrides for testing. Used by the language flags (Quebec / Mexico) and the
        // checkout phone field's country (Peter, 2026-09-13). withOverride false: tmv-country alone (tm-consent.js takes
        // ?tm_country only when it asks for the opt-in region).
        getCountry: function (withOverride = true) {
            let returnValue = '';
            try {
                let override = withOverride ? new URLSearchParams(window.location.search).get('tm_country') : null;
                returnValue = override ? override : (Cookies.get('tmv-country') ?? '');
            } catch (e) {}
            return /^[a-z]{2}$/i.test(returnValue) ? returnValue.toLowerCase() : '';
        },

        setCountry: function (iso2) {
            try {
                if (/^[a-z]{2}$/i.test(iso2)) {
                    Cookies.set('tmv-country', iso2.toLowerCase(), { expires: 365, secure: true });
                }
            } catch (e) {}
        },

        // the country, looking it up (and remembering it) when this is the first visit; '' when it cannot be known.
        // One lookup per page: the language flags (language-dropdown-menu.js) and tm-consent.js share it.
        resolveCountry: function (withOverride = true) {
            let known = this.getCountry(withOverride);
            if (known || typeof window.fetch !== 'function') {
                return Promise.resolve(known);
            }
            if (this.countryLookup) {
                return this.countryLookup;
            }
            let self = this;
            this.countryLookup = fetch('/cdn-cgi/trace', { credentials: 'omit' })
                .then(function (response) { return response.ok ? response.text() : ''; })
                .then(function (text) {
                    let match = /(?:^|\n)loc=([A-Za-z]{2})/.exec(text);
                    if (!match || /^(xx|t1)$/i.test(match[1])) { return ''; }
                    self.setCountry(match[1]);
                    return match[1].toLowerCase();
                })
                .catch(function () { return ''; });
            return this.countryLookup;
        },

        isSalesDepartment: function () {
            return this.getLatestOrderRef() === null;
        },

        getLatestOrderRef() {
            let latestOrder = null;
            let orderTags = this.getTags('orders', 1, true, true)
            if (orderTags.length > 0) {
                latestOrder = orderTags[0];
            }
            return latestOrder;
        },

        overrideTagsCookie(tags) {
            try {
                if (!tmUtils.consentAllows('analytics')) { // tmv-tags: analytics consent
                    return;
                }
                tmUtils.saveToLocalStorage('tmv-tags', tags, 90 * 24 * 60 * 60);
            } catch (e) {}
        },

        getTags: function (group = 'all', count = 0, latestFirst = true, removePrefix = false) {
            let tags = [];
            try {
                let currentStoredTags = tmUtils.getFromLocalStorage('tmv-tags') || [];
                tags = (typeof currentStoredTags !== 'undefined' && currentStoredTags !== null && Array.isArray(currentStoredTags)) ? currentStoredTags : []
            } catch (e) {}

            let startsWith = '';
            if (group === 'orders') {
                startsWith = 'or-'
            }
            else if (group === 'products') {
                startsWith = 'p-'
            }
            else if (group === 'checkouts') {
                startsWith = 'ch-'
            }
            if (startsWith.length > 0) {
                tags = tags.filter(function(tag){
                    return tag.startsWith(startsWith);
                })
            }

            if (removePrefix) {
                tags = tags.map(function(tag){
                    return tag.replaceAll('or-', '').replaceAll('p-', '').replaceAll('ch-', '');
                })
            }

            if (latestFirst) {
                tags = tags.reverse();
            }

            if (count > 0) {
                tags = tags.slice(0, count);
            }

            return tags;
        },

        addTag: function (newTag) {
            newTag = newTag.trim();
            if (newTag.length > 0) {
                this.removeTag(newTag); /* remove if exist tag. So added at last - required to maintain sequence.  */
                let currentTags = this.getTags('all', 0, false);
                currentTags.push( newTag );
                this.overrideTagsCookie(currentTags);
            }
        },

        removeTag: function (tag) {
            try {
                let currentTags = this.getTags('all', 0, false);
                let findTagIndex = currentTags.indexOf(tag);
                if (findTagIndex >= 0) {
                    currentTags.splice(findTagIndex, 1);
                    this.overrideTagsCookie(currentTags);
                }
            } catch (e) {}
        },

        getCoolNav: function (latestFirst = true) {
            let coolNav = [];
            try {
                coolNav = tmUtils.getFromLocalStorage('cool-nav') || [];
                coolNav = (typeof coolNav !== 'undefined' && coolNav !== null && Array.isArray(coolNav)) ? coolNav : []
            } catch (e) {}
            if (latestFirst) {
                coolNav = coolNav.reverse();
            }
            return coolNav;
        },

        getCoolNavLog: function (latestFirst = true) {
            let coolNav = this.getCoolNav(latestFirst);
            return coolNav.map(item => ({
                type: item.type,
                ...(item.destination !== undefined && { destination: item.destination }),
                ...(item.tmActivityId !== undefined && { tmActivityId: item.tmActivityId })
            }));
        },

        getFocusedDestinationName: function () {
            let coolNav = this.getCoolNav();
            let focusedImageDestinationName = null;
            coolNav.forEach(function(element){
                if (element.hasOwnProperty('destinationTitle') && focusedImageDestinationName === null) {
                    focusedImageDestinationName = element.destinationTitle;
                }
            });
            return focusedImageDestinationName;
        },

        getFocusedImage: function () {
            let coolNav = this.getCoolNav();
            let focusedImageUrl = null;
            coolNav.forEach(function(element){
                if (element.hasOwnProperty('destinationImage') && focusedImageUrl === null) {
                    focusedImageUrl = element.destinationImage;
                }
            });
            return focusedImageUrl;
        },

        getViewedProducts: function (restrictTmProductIds = []) {
            let viewedProducts = [];
            let takenProductIds = [];
            let coolNav = this.getCoolNav();
            coolNav.forEach(function(element){
                if(element.type === 'activityDetail' && element.hasOwnProperty('tmActivityId')) {
                    if (!takenProductIds.includes(element.tmActivityId) && (restrictTmProductIds.length === 0 || restrictTmProductIds.includes(parseInt(element.tmActivityId)))) {
                        let data = {
                            tmProductId: element.tmActivityId,
                            blogProductId: null,
                        };
                        if (element.hasOwnProperty('activity') && element.activity !== element.tmActivityId) {
                            data.blogProductId = element.activity;
                        }
                        viewedProducts.push(data);
                        takenProductIds.push(data.tmProductId);
                    }
                }
            });
            return viewedProducts;
        },

        getCurrentTimeHour: function () {
            let now = new Date();
            return now.getHours(); /* 0 - 23 */
        },

        saveSelectedDates: function(startDate, endDate) {
            try {
                if(!startDate && !endDate) {
                    window.localStorage.removeItem('startDate');
                    window.localStorage.removeItem('endDate');
                }
                else {
                    if(!endDate) {
                        window.localStorage.setItem('startDate', startDate);
                        window.localStorage.setItem('endDate', startDate);
                    }
                    else {
                        window.localStorage.setItem('startDate', startDate);
                        window.localStorage.setItem('endDate', endDate);
                    }
                }
                return true;
            }
            catch(error) {
                return false;
            }
        },

        getSavedStartDate: function() {
            let startDate = null;

            try {
                startDate = localStorage.getItem('startDate');
            }
            catch(error) {

            }

            return startDate;
        },

        getSavedEndDate: function() {
            let endDate = null;

            try {
                endDate = localStorage.getItem('endDate');
            }
            catch(error) {

            }

            return endDate;
        },

        // coolAttribution credits the ad or partner that sent the visitor: advertising consent (Consent banner Flow 6)
        setAttributionCookies: function() {
            if (typeof tmUtils === 'undefined' || !tmUtils.consentAllows('advertising')) {
                return;
            }
            let ignoreValues = [
                '{src}',
                '{lang}',
                '{currency}',
                '{product_id',
                '{option_id}',
                '{surface}',
                '{funnel}',
                '{GOOGLE-ADS-CLICK-SOURCE}',
            ];

            if (typeof tmBlogRequestJsVars === 'undefined' || tmBlogRequestJsVars.no_attribution_cookie) { // none on a booking page
                return;
            }

            let validParameters = tmBlogRequestJsVars.valid_attribution_cookie_parameters || [];

            let parametersToSave = {};

            for (const [key, value] of new URLSearchParams(new URL(window.location.href).search).entries()) {
                if(validParameters.includes(key) && value.trim() !== '' && !ignoreValues.includes(value)) {
                    parametersToSave[key] = value;
                }
            }

            let extractDomainNameFromUrl = function(url){
                let domain;
                //find & remove protocol (http, ftp, etc.) and get domain
                if (url.indexOf("://") > -1) {
                    domain = url.split('/')[2];
                }
                else {
                    domain = url.split('/')[0];
                }
                //find & remove www
                if (domain.indexOf("www.") > -1) {
                    domain = domain.split('www.')[1];
                }

                domain = domain.split(':')[0]; //find & remove port number
                domain = domain.split('?')[0]; //find & remove url params

                return domain;
            }

            let oldCookieParams = Object.fromEntries(new URLSearchParams(Cookies.get('coolAttribution')));

            let newCookieParams = Object.fromEntries(new URLSearchParams(parametersToSave));
            if (document.referrer.length > 0) {
                let referrerDomain = extractDomainNameFromUrl(document.referrer)
                let currentPlainDomain = extractDomainNameFromUrl(window.location.href)
                if (!referrerDomain.includes(currentPlainDomain)) {
                    newCookieParams.http_referrer = referrerDomain
                }
            }

            let cookieParams = Object.assign(oldCookieParams, newCookieParams);

            let cookieParamsAsString = new URLSearchParams(cookieParams).toString();

            Cookies.set('coolAttribution', cookieParamsAsString, { expires: 30, secure: true });
        },

        removeAttributionCookies: function() {
            Cookies.remove('coolAttribution');
        },

        setNavigationCookies: function() {
            if (typeof tmBlogRequestJsVars === 'undefined') {
                return;
            }

            let newItem= tmBlogRequestJsVars.navigation_cookie_data || {};

            if(newItem.type && tmUtils.consentAllows('analytics')) { // cool-nav: analytics consent
                let navigationItems = tmUtils.getFromLocalStorage('cool-nav') || [];
                navigationItems = (typeof navigationItems !== 'undefined' && navigationItems !== null && Array.isArray(navigationItems)) ? navigationItems : []
                if(navigationItems.length > 20) {
                    navigationItems.shift();
                }
                navigationItems.push(newItem);
                tmUtils.saveToLocalStorage('cool-nav', navigationItems, 30 * 24 * 60 * 60);
            }
            if (newItem.type === 'providersSinglePage' || newItem.type === 'providersSingle') { // coupon_code is necessary
                Cookies.set('coupon_code', 'SECRET', { expires: 30, secure: true });
            }
        }
    }
}(window);
